import { RootState } from '../../../../../redux/store.model';
import { createSelector } from '@reduxjs/toolkit';
import { getAllDevicesFromStoreSelector } from '../../../Store.selectors';
import ZoneApi from '../ZoneApi';

const getStoreApiSliceState = (state: RootState) =>
  state[ZoneApi.reducerPath as keyof RootState];

export const getDevicesWithZoneSettingsSelector = createSelector(
  [getAllDevicesFromStoreSelector, getStoreApiSliceState],
  (devices, storeApiSliceState) =>
    devices.map((device) => {
      const response = ZoneApi.endpoints.getZoneSettings.select(device.uuid)({
        [ZoneApi.reducerPath]: storeApiSliceState,
      } as RootState);
      return {
        device,
        zoneSettings: response.data,
        zoneSettingsLoading: response?.isLoading,
      };
    })
);

export default getDevicesWithZoneSettingsSelector;
